import React from 'react';
import { Box, Container, Flex, Text } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';

import './style.scss';

/**
 * Renders the footer component for the application.
 *
 * @returns {JSX.Element} The footer component.
 */
export default function Footer() {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  return (
    <footer id="footer">
      <Container size={isMobile ? '1' : '4'}>
        <section className="container text-wrap">
          <Flex direction={isMobile ? 'column' : 'row'} align={isMobile ? 'start' : 'center'}>
            {isMobile && (
              <Box className="logo">
                <a title="새 창 열림" href="http://www.wa.or.kr/board/list.asp?BoardID=0006" target="_blank">
                  <img
                    class="wa"
                    alt="(사)한국장애인단체총연합회 한국정보접근성인증평가원 웹 접근성 우수사이트 인증마크(WA인증마크)"
                    src={require('assets/images/logo/logo-wa.png')}
                    className="wa"
                  />
                </a>
                <Text className="swedu">SW미래채움</Text>
              </Box>
            )}

            <Box className="policy">
              {/*<a href="/Terms" className="body1 font-bold" title="새창으로 이용약관으로 이동">이용약관</a>*/}
              {/*<Link to={'/privacy'} className="body1 font-bold" title="개인정보처리방침으로 이동">
                개인정보처리방침
              </Link>*/}
            </Box>

            {!isMobile && (
              <Box className="logo">
                <a href="http://www.wa.or.kr/board/list.asp?BoardID=0006" title="새 창 열림" rel="noopener noreferrer" target="_blank">
                  <img
                    src={require('assets/images/logo/logo-wa.png')}
                    alt="(사)한국장애인단체총연합회 한국웹접근성인증평가원 웹 접근성 우수사이트 인증마크(WA인증마크)"
                    className="wa"
                  />
                </a>
                <Text className="swedu">SW미래채움</Text>
              </Box>
            )}
          </Flex>

          <address className="body2">주소 : 서울특별시 마포구 월드컵북로 396, 누리꿈스퀘어 연구개발타워 14F 지역SW융합비즈마루</address>
          <Text as="p" className="body3 copyright">
            COPYRIGHT SW미래채움. ALL RIGHTS RESERVED.
          </Text>
        </section>
      </Container>
    </footer>
  );
}
